export default "__VITE_ASSET__1QgyAMta__"